import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Holiday } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditHoliday from './EditHoliday.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        holiday: Holiday;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'HolidaysTableActions',
  props: {
    holiday: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.holiday }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).HOLIDAYS_UPDATE))
        ? (_openBlock(), _createBlock(EditHoliday, {
            key: 0,
            holiday: _ctx.holiday
          }, null, 8, ["holiday"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).HOLIDAYS_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.salary.holidays.destroy', _ctx.holiday.id),
            "query-key": [_unref(QueryKey).HOLIDAYS],
            header: "holidays.delete.title",
            description: "holidays.delete.content"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})